import { render } from "./ProductReferencesContainer.vue?vue&type=template&id=10a8091e&scoped=true"
import script from "./ProductReferencesContainer.vue?vue&type=script&lang=js"
export * from "./ProductReferencesContainer.vue?vue&type=script&lang=js"

import "./ProductReferencesContainer.vue?vue&type=style&index=0&id=10a8091e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a8091e"]])

export default __exports__